import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';
import { PipesModule } from './pipe/pipes/pipes.module';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    PipesModule

  ],
  exports: [
    MaterialModule,
    PipesModule

  ]
})
export class SharedModule { }
